import React, { useMemo } from 'react';
import { Platform, TouchableOpacity } from 'react-native';
import I18n from '../../../../components/shared/i18n/I18n.component';
import ImageIcon from '../../../../components/shared/Icon/ImageIcon.component';
import colors from '../../../../config/colors';
import { View } from '@react-pdf/renderer';

const HideViewButtons = ({
	setDisplayCardMap,
	displayCardMap,
	canDisplay,
}: any) => {
	const mapArr = useMemo(
		() => ['monthly', 'yearly', 'employeeForm', 'workPaperDraft'],
		[],
	);

	return (
		<View style={{display: 'flex', flexDirection:'row', gap: 16, width: '100%'}}>
			{mapArr.map(
				key =>
					canDisplay[key] && (
						<TouchableOpacity
							onPress={() => {
								setDisplayCardMap(key, !displayCardMap[key]);
							}}
							style={{
								display: 'flex',
								flex: '1 0 0',
								flexDirection: 'row-reverse',
								backgroundColor: displayCardMap[key]
									? colors.titlePrimary
									: colors.white,
								//paddingHorizontal: 25,
								paddingVertical: 9,
								//marginLeft: 15,
								borderRadius: 10,
								height: 31,
								justifyContent: 'center',
								alignItems: 'center',
								...Platform.select({
									web: {
										boxShadow:
											'0px 4px 15px rgba(0, 0, 0, 0.15)',
									},
								}),
							}}
						>
							<ImageIcon
								name={displayCardMap[key] ? 'eyeOff' : 'eyeOn'}
								height={displayCardMap[key] ? 16 : 11.5}
								width={16}
								style={{ marginLeft: 8 }}
							/>
							<I18n
								weight='400'
								size={14}
								color={
									displayCardMap[key] ? 'white' : 'darkGrey'
								}
							>{`repDashboard.buttons.${key}`}</I18n>
						</TouchableOpacity>
					),
			)}
		</View>
	);
};

export default HideViewButtons;
